import { CapoPlugin } from "/usr/src/rt-details-2023/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];